module.exports = __webpack_public_path__ + "static/media/HIC1.ee0bdbb4.jpg";